const createOrUpdateUserCurrentProfessionalDetailsGraphQlMutation = (
  withMutation = true
): { mutation: string; type: string } => {
  const failureFields = `
    failure_response {
      res_status
      response
    }
  `;

  const successFields = `
    completion_percentage
  `;

  const mutation = `create_or_update_user_professional_details(user_professional_details_input: $user_professional_details_input) {
          ${successFields}
          ${failureFields}
        }`;

  if (withMutation)
    return {
      mutation: `
    mutation CreateOrUpdateUserProfessionalDetails($user_professional_details_input: UserProfessionalDetailsInput!) {
      ${mutation}
    }
  `,
      type: 'UserProfessionalDetailsInput!'
    };
  else return { mutation, type: 'UserProfessionalDetailsInput!' };
};

export { createOrUpdateUserCurrentProfessionalDetailsGraphQlMutation };
